import { render } from "./SignTemplate.vue?vue&type=template&id=056a0943&scoped=true"
import script from "./SignTemplate.vue?vue&type=script&lang=js"
export * from "./SignTemplate.vue?vue&type=script&lang=js"

import "./SignTemplate.vue?vue&type=style&index=0&id=056a0943&lang=css"
import "./SignTemplate.vue?vue&type=style&index=1&id=056a0943&scoped=true&lang=css"

import exportComponent from "/data/vstsagent02/user/3807/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056a0943"]])

export default __exports__